import { render, staticRenderFns } from "./SwiperSlide.vue?vue&type=template&id=79aad503"
import script from "./SwiperSlide.js?vue&type=script&lang=js&external"
export * from "./SwiperSlide.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports